export const environment = {
  production: true,
  hideNavbar: false,
  url: "https://exon-iam-be-test.amitia-ai.com",
  allowedDomains: ["exon-iam-be-test.amitia-ai.com"],
  iccAppUrl: "https://inkcapture-test.exon.cz/",
  restricted_functions_whitelist: ["jan.valenta@exon.cz"],
};
